const FORMATS = {
  FINANCE: '0,00.00'
};

export default FORMATS;
